import { CurrentStateValidator } from '@colonist/game-mechanic-validators';
import { useGameStore } from '../GameStoreContext.ts';
import { useMemo } from 'react';
export const useCurrentStateValidator = ()=>{
    const currentState = useGameStore((state)=>state.gameState.currentState);
    const experimentalMechanicState = useGameStore((state)=>state.gameState.experimentalMechanicState);
    const playerColors = useGameStore((state)=>state.gameDetails.playOrder);
    const experimentalCurrentState = experimentalMechanicState === null || experimentalMechanicState === void 0 ? void 0 : experimentalMechanicState.currentState;
    const mechanicTurnColonistRushState = experimentalMechanicState === null || experimentalMechanicState === void 0 ? void 0 : experimentalMechanicState.mechanicTurnColonistRushState;
    const playerStates = experimentalMechanicState === null || experimentalMechanicState === void 0 ? void 0 : experimentalMechanicState.playerStates;
    const mechanicRobberColonistRushState = experimentalMechanicState === null || experimentalMechanicState === void 0 ? void 0 : experimentalMechanicState.mechanicRobberColonistRushState;
    return useMemo(()=>new CurrentStateValidator(currentState, experimentalCurrentState, mechanicTurnColonistRushState, playerStates, playerColors, mechanicRobberColonistRushState), [
        currentState,
        experimentalMechanicState,
        playerStates,
        playerColors
    ]);
};
